//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import constant from '~/const';

export default {
  props: {
    value: { type: Boolean, default: false },
    perProfile: { type: Number, default: 0 },
  },

  data() {
    return {
      input: {},
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    value(val) {
      if (val) {
        const { perProfile } = this;
        this.input.MaxRequisiteBundlesPerProfile = perProfile;
      }
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsRequisiteUser', {
      updateSettingsAction: 'updateSettings',
    }),

    async save() {
      const { input } = this;
      this.setGeneralProgress(true);
      try {
        const res = await this.updateSettingsAction(input);

        if (res) {
          this.model = false;
          this.setSuccessNotification('Settings updated');
        } else {
          this.setErrorNotification('Settings was not updated, try again');
        }
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },
  },
};
